var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgManReclining = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 510 510"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M134.286 332.833l-20.797 80.972V510h60.12V333.461z",
  fill: "#004381"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M353.489 269.995l10.13-92.046L353.489 120l-60-60h-61.99c-14.939 0-28.2 9.56-32.92 23.72l-.59 1.78a34.692 34.692 0 007.479 34.57l58.69 63.27-31.007 66.766 38.002 46.145 51.31 35.812z",
  fill: "#FB66C4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M322.464 332.062l-89.312-81.957-13.293 28.624-.015-.001 30.895 34.022L292.126 345l11.113 4.875L315.997 345z",
  fill: "#e5f5ff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M131.779 267.38L27.369 429.5l-8.858 13.754 35.073 52.61 9.785-12.364 110.12-150.039L218.62 345l37.119 6.25 36.387-6.25-72.282-66.272z",
  fill: "#0069b0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M248.62 405v-30h104.999l10-15.083-10-14.917H218.62v165h30v-75h104.999l10-17-10-13z",
  fill: "#6CBBED"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M368.62 239.757V345h-15.001v30h15.001v30h-15.001v30h15.001v75h30V210.604c0-.23-28.001-.772-28.001-.772z",
  fill: "#56ACE1"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M486.889 137.64a34.61 34.61 0 00-12.58-12.689L417.56 91.77l-9.937-5.865L353.489 120v149.995l26.64-53.295 87.52-28.851c14.23-4.68 23.841-17.97 23.841-32.949a34.725 34.725 0 00-4.601-17.26z",
  fill: "#E557B1"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M293.489 60c0 33.137 26.863 60 60 60l10-62.333-10-57.667c-33.136 0-60 26.863-60 60z",
  fill: "#ffdbcc"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M353.489 0v120c33.137 0 60-26.863 60-60s-26.863-60-60-60z",
  fill: "#fdbba7"
})));
export default SvgManReclining;